import { render } from "./StripeDemo.vue?vue&type=template&id=478693ff"
import script from "./StripeDemo.vue?vue&type=script&lang=js"
export * from "./StripeDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__